import { DATA } from '../../../constants/actionTypes';

const initialState = {
  type: null,
  lastFetched: Date.now(),
  success: null,
  isFetching: false,
  content: [],
  trainers: [],
  pastOrUpcoming: [],
  eventCreators: {
    results: [],
    currentUser: {
      id: null,
    },
  },
};

export const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case DATA.REQUEST:
      return _.extend({}, state, {
        isFetching: true,
        requestUrl: action.requestUrl,
      });

    case DATA.FAILURE:
      return _.extend({}, state, {
        isFetching: false,
        success: false,
      });

    case DATA.SUCCESS: {
      const { response, success, isFetching, lastFetched } = action;
      return _.extend({}, state, response.data, {
        isFetching,
        success,
        lastFetched,
      });
    }

    case DATA.GROUPS: {
      const { meta } = action;
      return _.extend({}, state, meta);
    }

    case DATA.TRAINERS: {
      const { payload } = action;
      return _.extend({}, state, {
        trainers: payload.results,
      });
    }

    case DATA.PAST_OR_UPCOMING: {
      const { payload } = action;
      return _.extend({}, state, {
        pastOrUpcoming: payload.results,
      });
    }

    case DATA.EVENT_CREATORS: {
      const { payload } = action;
      return _.extend({}, state, {
        eventCreators: {
          results: payload.results,
          currentUser: payload.currentUser,
        },
      });
    }

    default:
      return _.extend({}, initialState, state);
  }
};
